import Entity from './entity'

const ClientContact = new Entity('clientcontacts')

export default ClientContact
